import { render, staticRenderFns } from "./TableHierarchicalDocPackage.vue?vue&type=template&id=a9807794&"
import script from "./TableHierarchicalDocPackage.vue?vue&type=script&lang=js&"
export * from "./TableHierarchicalDocPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9807794')) {
      api.createRecord('a9807794', component.options)
    } else {
      api.reload('a9807794', component.options)
    }
    module.hot.accept("./TableHierarchicalDocPackage.vue?vue&type=template&id=a9807794&", function () {
      api.rerender('a9807794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/document-package/components/TableHierarchicalDocPackage.vue"
export default component.exports